export default {
    date_of_birth: 'Date of birth:',
    insurance: 'Insurance',
    group: 'Group # ',
    id: 'ID',
    primary_care: 'Primary Care',
    referral_records: 'REFERRAL RECORDS',
    attachments: 'Attachments:',
    note: 'NOTE',
}
